<template>
    <div class="container" >
        <div class="text-wrapper" v-motion :initial="{
                opacity: 0,
                y: 100,
            }" :visible-once="{
                opacity: 1,
                y: 0,
            }">
            <p class="contact">LinkedIn Interaction</p>
            <p class="title">A developer who can share !</p>
            <p class="description">One who love’s to share about his thoughts.</p>
        </div>
        <div class="cards-wrapper" v-motion :initial="{
                opacity: 0,
                y: 100,
            }" :visible-once="{
                opacity: 1,
                y: 0,
            }">
            <div class="platform-card" v-for="post in posts" >
                <div class="card-header">
                    <img :src="post.image" alt="">
                </div>
                <div class="card-body">
                    <div class="profile-section">
                        <div class="profile-img">
                            <img :src="profileDetails.image" alt="">
                        </div>
                        <div class="profile-details">
                            <div class="name-wrapper">
                                <p class="profile-name">{{ profileDetails.name }}</p>
                                <img class="mini-icon" :src="require('@/assets/icons/linkedin-mini-icon.svg')" alt="">
                            </div>
                            <p class="designation">{{ profileDetails.about }}</p>
                        </div>
                    </div>
                    <div class="content-section">
                        <p class="section-title">{{ post.title }}</p>
                        <p class="section-description">{{ post.description }}</p>
                        <a :href="post.url" class="readmore-btn">Read More</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import sveltekitArticleBanner from '@/assets/images/sveltekit-article-banner.png'
import profileImg from '@/assets/images/murugesh-profile-img.png';
export default {
    name: 'LoveToCode',
    data() {
        return {
            profileDetails: {
                name: 'Murugesh Raja',
                about: 'SDE at Fidelity Investments | Ex- Codestax.AI, TCS | Full stack developer',
                image: profileImg
            },
            posts: [
                {
                    image: sveltekitArticleBanner,
                    title: 'Creating a SvelteKit project',
                    description: 'Curious about Sveltekit? Wondering how it stacks up against Vue.js? Look no further! In my medium article,',
                    url: 'https://www.linkedin.com/posts/murugesh-raja_sveltekit-vuejs-webdevelopment-activity-7116468973910577153-9FHv?utm_source=share&utm_medium=member_desktop'
                },
                // {
                //     image: sveltekitArticleBanner,
                //     title: 'Creating a SvelteKit project',
                //     description: 'Curious about Sveltekit? Wondering how it stacks up against Vue.js? Look no further! In my medium article,'
                // }
            ]

        };
    },
    components: {

    },
    computed: {

    },
    methods: {

    }
}
</script>

<style scoped>
.container {
    background-color: var(--primary-bg-color);
    padding: 80px 120px;
    display: flex;
    gap: 2rem;
    flex-direction: column;
    position: relative;
    overflow: hidden;
}

.text-wrapper {
    display: flex;
    gap: 12px;
    flex-direction: column;
    text-align: center;
}

.contact {
    font-size: 1.5rem;
    font-weight: 600;
    background: linear-gradient(#B66BE1, #FF6267, #FFA84B);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.title {
    font-size: 2rem;
    font-weight: 600;
    color: var(--primary-text-color);
}

.description {
    font-size: 1rem;
    color: var(--secondary-text-color);
}

.cards-wrapper {
    display: flex;
    gap: 2rem;
    flex-wrap: wrap;
    justify-content: center;
}

.platform-card {
    width: 375px;
    display: flex;
    flex-direction: column;
    border: 1px solid #252626;
    border-radius: 20px;
    overflow: hidden;
    min-height: 320px;
    transition: all 0.3s ease-in-out;
}

.platform-card:hover {
    box-shadow: 6px 5px 8px #B66BE1;
    transform: scale(1.05);
}

.card-header {
    display: flex;
    justify-content: space-between;
    background-color: #0E141E;
    height: 7.5rem;
    align-items: center;
    flex-wrap: wrap;
}

.card-header img {
    width: 100%;
    height: 100%;
    object-fit: cover;

}

.card-header.secondary {
    background-color: #202020;
}

.hint {
    font-size: 1rem;
    color: #2EC866;
}

.link {
    color: #2EC866;
}

.link.secondary,
.hint.secondary {
    color: #EBA340;
}


.card-body {
    background-color: #0C0C0D;
    padding: 1rem 1.5rem;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 0.5rem;
}

.content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.description-wrapper {
    padding-left: 1.5rem;
}

.profile-section {
    display: flex;
    gap: 1rem;
    align-items: flex-start;
}

.profile-details {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;

}

.mini-icon {
    width: 20px;
    height: 20px;
}

.profile-name {
    font-size: 1rem;
}

.designation {
    font-size: 0.8rem;
    white-space: wrap;
    color: var(--secondary-text-color);
}


.profile-img {
    width: 70px;
    height: 50px;
    overflow: hidden;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.profile-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.name-wrapper {
    display: flex;
    gap: 1rem;
    align-items: center;
}

.content-section {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.section-title {
    font-size: 1rem;
}

.section-description {
    font-size: 1rem;
    color: var(--secondary-text-color);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.readmore-btn {
    color: #417DCD;
    text-align: left;
    font-size: 0.9rem;
}

@media (max-width: 900px) {

    .title {
        font-size: 2rem;
    }

    .container {
        padding: 3.5rem;
    }
}

@media (max-width: 768px) {
    .container {
        padding: 2rem;
    }

    .text-wrapper {
        text-align: left;
        gap: 10px;
    }

    .contact, .description, .section-title, .section-description, .profile-name {
        font-size: 0.9rem;
    }

    .title {
        font-size: 1.2rem;
    }

    .card-body {
        padding: 1rem;
    }
}
</style>